// Mock data for LawForLayman clone

export const SITE = {
  name: 'LawForLayman',
  tagline: 'Indian law explained in plain words. Free legal aid for those who need it most.',
  email: 'contact@lawforlayman.com',
  helpline: '9944562638',
  address: 'New Delhi, Chennai, Andhra Pradesh, Telangana, Karnataka, India',
  logoUrl: 'https://assets.zyrosite.com/cdn-cgi/image/format=auto,w=375,fit=crop/hFV2DTYHNTC0Zn5H/7493f2b6-a582-4dec-ba8e-51840437b853-PkqkMGo91dk8eTUW.JPG',
};

export const NAV_LINKS = [
  { label: 'Home', path: '/' },
  { label: 'Find a Lawyer', path: '/find-a-lawyer' },
  { label: 'Legal Guides', path: '/legal-guides' },
  { label: 'Free Legal Aid', path: '/free-aid' },
  { label: 'Shop', path: '/shop' },
  { label: 'Enroll as Advocate', path: '/enroll-advocate' },
  { label: 'About', path: '/about' },
  { label: 'Get Help', path: '/get-help' },
];

export const PILLARS = [
  {
    id: 'education',
    badge: 'Education',
    title: 'Plain-language translation',
    description: 'We break down complex statutory jargon, petitions, and notices into simple, regional terms you can actually understand.',
    icon: 'BookOpen',
  },
  {
    id: 'representation',
    badge: 'Representation',
    title: 'Verified advocates',
    description: 'Connect directly with registered lawyers across India who are committed to transparent, empathetic, and affordable counsel.',
    icon: 'Users',
  },
  {
    id: 'equity',
    badge: 'Equity',
    title: 'No-cost legal aid',
    description: 'We offer direct access to completely free legal services and document drafting for citizens living below the poverty line.',
    icon: 'Shield',
  },
];

export const STATS = [
  { id: 1, value: '25,000+', label: 'citizens assisted', icon: 'UserCheck' },
  { id: 2, value: '7,000+', label: 'verified advocates', icon: 'Award' },
  { id: 3, value: '22', label: 'states covered', icon: 'MapPin' },
];

export const LAWYERS = [
  { id: 1, name: 'Adv. Priya Sharma', city: 'New Delhi', specialty: 'Family & Matrimonial', experience: '12 yrs', rating: 4.9, languages: ['Hindi', 'English'], fee: 'Free consult' },
  { id: 2, name: 'Adv. Rajesh Iyer', city: 'Chennai', specialty: 'Criminal Defence', experience: '18 yrs', rating: 4.8, languages: ['Tamil', 'English'], fee: '₹500 onwards' },
  { id: 3, name: 'Adv. Ananya Reddy', city: 'Hyderabad', specialty: 'Property & Land', experience: '9 yrs', rating: 4.7, languages: ['Telugu', 'English'], fee: 'Free consult' },
  { id: 4, name: 'Adv. Vikram Singh', city: 'Bengaluru', specialty: 'Consumer Protection', experience: '7 yrs', rating: 4.6, languages: ['Kannada', 'Hindi', 'English'], fee: '₹300 onwards' },
  { id: 5, name: 'Adv. Meera Nair', city: 'Kochi', specialty: 'Women & Child Rights', experience: '14 yrs', rating: 5.0, languages: ['Malayalam', 'English'], fee: 'Free consult' },
  { id: 6, name: 'Adv. Arjun Patel', city: 'Ahmedabad', specialty: 'Labour & Employment', experience: '11 yrs', rating: 4.7, languages: ['Gujarati', 'Hindi', 'English'], fee: '₹400 onwards' },
  { id: 7, name: 'Adv. Kavita Joshi', city: 'Mumbai', specialty: 'Cyber & IT Law', experience: '8 yrs', rating: 4.8, languages: ['Marathi', 'Hindi', 'English'], fee: '₹600 onwards' },
  { id: 8, name: 'Adv. Sandeep Kumar', city: 'Kolkata', specialty: 'Civil Disputes', experience: '15 yrs', rating: 4.6, languages: ['Bengali', 'Hindi', 'English'], fee: 'Free consult' },
  { id: 9, name: 'Adv. Lakshmi Rao', city: 'Visakhapatnam', specialty: 'Tenancy & Rent', experience: '10 yrs', rating: 4.5, languages: ['Telugu', 'English'], fee: '₹350 onwards' },
];

export const SPECIALTIES = [
  'All',
  'Family & Matrimonial',
  'Criminal Defence',
  'Property & Land',
  'Consumer Protection',
  'Women & Child Rights',
  'Labour & Employment',
  'Cyber & IT Law',
  'Civil Disputes',
  'Tenancy & Rent',
];

export const GUIDES = [
  {
    id: 1,
    category: 'Consumer Rights',
    title: 'What to do if a shopkeeper refuses to give you a bill',
    excerpt: 'A step-by-step guide on filing a complaint under the Consumer Protection Act, 2019 — in your own language.',
    readTime: '5 min read',
  },
  {
    id: 2,
    category: 'Family Law',
    title: 'Understanding maintenance under Section 125 CrPC',
    excerpt: 'Who can claim, how much, and where to file — written for the citizen, not the courtroom.',
    readTime: '7 min read',
  },
  {
    id: 3,
    category: 'Property',
    title: 'Reading a sale deed before you sign',
    excerpt: 'The five clauses every buyer must check, with simple examples drawn from real cases across India.',
    readTime: '6 min read',
  },
  {
    id: 4,
    category: 'Cyber Safety',
    title: 'Reporting online fraud and recovering money',
    excerpt: 'How to use the 1930 helpline, the cybercrime.gov.in portal, and what evidence to preserve.',
    readTime: '4 min read',
  },
  {
    id: 5,
    category: 'Labour',
    title: 'When your employer withholds salary or PF',
    excerpt: 'A plain-English explainer on the Payment of Wages Act and where to lodge your complaint.',
    readTime: '6 min read',
  },
  {
    id: 6,
    category: 'Women & Child Rights',
    title: 'Domestic Violence Act — your protections explained',
    excerpt: 'The orders a court can pass, the role of the Protection Officer, and free shelter options.',
    readTime: '8 min read',
  },
];

export const FAQS = [
  {
    q: 'Who qualifies for free legal aid?',
    a: 'Under the Legal Services Authorities Act, 1987, free aid is available to women, children, SC/ST citizens, persons with disability, industrial workmen, victims of trafficking, and any citizen whose annual income is below the threshold notified by their State Legal Services Authority.',
  },
  {
    q: 'Are the advocates listed here verified?',
    a: 'Yes. Every advocate on our platform is verified against the State Bar Council enrolment register before being listed. Their enrolment number and primary jurisdiction are checked at the time of onboarding.',
  },
  {
    q: 'Can I get help in my regional language?',
    a: 'Absolutely. Our guides are progressively translated into 11 Indian languages, and you can filter advocates by the languages they speak fluently.',
  },
  {
    q: 'Is my conversation confidential?',
    a: 'Communications routed through LawForLayman are protected by attorney-client privilege once a formal engagement begins. We never share your personal details with third parties.',
  },
  {
    q: 'How quickly will I hear back after requesting aid?',
    a: 'For free aid requests, our team responds within 24 hours on working days. For paid consultations booked through the platform, most advocates respond within 4 working hours.',
  },
];
